import { render, staticRenderFns } from "./ChatBoxNew.vue?vue&type=template&id=e51b0496&scoped=true&"
import script from "./ChatBoxNew.vue?vue&type=script&lang=js&"
export * from "./ChatBoxNew.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChatBoxNew.vue?vue&type=style&index=1&id=e51b0496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51b0496",
  null
  
)

export default component.exports